import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { StoreProvider } from "./context/Storecontext";
import { InquiryProvider } from "./context/InquiryContext"; // 👈 add this
import InquiryModal from "./components/InquiryModal"; // 👈 add this
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import "./App.css";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ShopPage from "./pages/ShopPage";
import ShopListPage from "./pages/ShopListPage";
import ProductDetailsPage from "./pages/ProductDetailsPage";
import ProductGroupedPage from "./pages/Productgroupedpage";
import ProductSidebarPage from "./pages/Productsidebarpage";
import CartPage from "./pages/CartPage";
import WishlistPage from "./pages/Wishlistpage";
import BlogPage from "./pages/BlogPage";
import BlogDetailsPage from "./pages/BlogDetailsPage";
import BlogSidebarPage from "./pages/BlogSidebarPage";
import SearchResultsPage from "./pages/Searchresultspage";
import {
  ContactPage,
  FAQPage,
  LoginPage,
  NotFoundPage,
} from "./pages/OtherPages";

import PrivateLabelPage from "./pages/Partner";
import BrochurePage from './pages/BrochurePage';
// import BrochureViewPage from './pages/BrochureViewPage';

function App() {
  return (
    <StoreProvider>
      <InquiryProvider>
        {" "}
        {/* 👈 wrap everything */}
        <Router basename={process.env.PUBLIC_URL}>
          <ScrollToTop />
          <div className="flex flex-col min-h-screen">
            <Header />
            <div className="flex-1">
              <Routes>
                <Route path="/home" element={<HomePage />} />
                <Route path="/" element={<HomePage />} />
                <Route path="/about" element={<AboutPage />} />
                {/* <Route path="/shop" element={<ShopPage />} /> */}
                <Route path="/products" element={<ShopPage />} />
                <Route
                  path="/packaging-private-labelling"
                  element={<PrivateLabelPage />}
                />
                <Route path="/shop-list" element={<ShopListPage />} />
                <Route
                  path="/product-details"
                  element={<ProductDetailsPage />}
                />
                <Route
                  path="/product-details/:id"
                  element={<ProductDetailsPage />}
                />
                <Route
                  path="/product-grouped"
                  element={<ProductGroupedPage />}
                />
                <Route
                  path="/product-sidebar"
                  element={<ProductSidebarPage />}
                />
                <Route path="/cart" element={<CartPage />} />
                <Route path="/wishlist" element={<WishlistPage />} />
                <Route path="/search" element={<SearchResultsPage />} />
                <Route path="/blog" element={<BlogPage />} />
                <Route path="/blog-details/:id" element={<BlogDetailsPage />} />
                <Route path="/blog-sidebar" element={<BlogSidebarPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/faq" element={<FAQPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/brochure" element={<BrochurePage />} />
                <Route path="*" element={<NotFoundPage />} />
                {/* <Route path="/brochure/:slug" element={<BrochureViewPage />} /> */}
              </Routes>
            </div>
            <Footer />
          </div>
          <InquiryModal /> {/* 👈 render the modal once, at top level */}
        </Router>
      </InquiryProvider>
    </StoreProvider>
  );
}

export default App;
